import { z } from 'zod';
import { PAYMENT_METHODS, UNITS } from '../enums';

// ── primitives ────────────────────────────────────────────────────────────────
const toStr = (v: unknown) => (typeof v === 'number' ? String(v) : v);
export const zId = z.string().uuid();
/** Money on the wire: decimal string, max 2 dp (numbers accepted and stringified) */
export const zMoney = z.preprocess(toStr, z.string().regex(/^-?\d{1,12}(\.\d{1,2})?$/, 'invalid_money'));
export const zMoneyPos = z.preprocess(toStr, z.string().regex(/^\d{1,12}(\.\d{1,2})?$/, 'invalid_money'));
export const zQty = z.preprocess(toStr, z.string().regex(/^-?\d{1,9}(\.\d{1,3})?$/, 'invalid_qty'));
export const zQtyPos = z.preprocess(toStr, z.string().regex(/^\d{1,9}(\.\d{1,3})?$/, 'invalid_qty'));
export const zFactor = z.preprocess(toStr, z.string().regex(/^\d{1,8}(\.\d{1,4})?$/, 'invalid_factor'));
export const zDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'invalid_date');
export const zIso = z.string().datetime({ offset: true });
export const zText = (max = 500) => z.string().trim().max(max);
export const zMethod = z.enum(PAYMENT_METHODS);
export const zUnitName = z.enum(UNITS);
export const zDiscount = z.object({ type: z.enum(['percent', 'amount']), value: zMoneyPos });
/** v10: a photo stored by POST /media — a capability path, never a third-party URL */
export const MEDIA_URL_RE = /^\/api\/v1\/media\/p\/[A-Za-z0-9_-]{22,64}\.webp$/;
export const zMediaUrl = z.string().max(120).regex(MEDIA_URL_RE, 'invalid_media_url');

